import { render, staticRenderFns } from "./SomethingWrongAlert.vue?vue&type=template&id=47a74660"
import script from "./SomethingWrongAlert.vue?vue&type=script&lang=js"
export * from "./SomethingWrongAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports